import { makeStyles } from "@material-ui/styles"
import { Colors } from '../../../types/colors'

export const statTileStyle = makeStyles(() => ({

}))
